export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/full_outfit.89f40ef.svg";